import React from 'react';
import { createRoot } from 'react-dom/client';
import './react-polyfill';
import App from './App.tsx';
import './index.css';

// Initialize error handling as early as possible
import { errorHandler } from './utils/errorHandler';
errorHandler.initialize();

// Register Service Worker for PWA functionality
import { registerServiceWorker } from './utils/registerServiceWorker';

// Register service worker
if (import.meta.env.PROD) {
  registerServiceWorker();
} else {
  console.log('🔧 Development mode: Service Worker not registered');
}

// Note: PWA install prompt is now handled by the PWAInstallPrompt component in App.tsx
// This allows for role-based visibility (admin only)

createRoot(document.getElementById("root")!).render(<App />);
